import React from 'react';

import moment from 'moment';
// import { platform } from 'chart.js';

export const mediaPlanListoptions = {
  columns: [
    { id: 1, name: 's.no', label: 'S.No.', sortable: false, type: 'number',  },
    { id: 2, name: 'name', label: 'Plan Name', sortable: true, type: 'string',component: (row) => <div title={row.name}>{row.name.length > 28 ? `${row.name.slice(0,28)} ...`: row.name }</div>},
    { id: 3, name: 'brandName', label: 'Brand Name', sortable: true, type: 'string' },
    { id: 4, name: 'platforms', label: 'DSP Platform', sortable: false, type: 'string' , component: (row) => row.platforms.length > 0 ? row.platforms.map((ro, i) => <span>{`${ro}`} {row.platforms.length - 1 === i ? '': <>, &nbsp;&nbsp;</>}</span>) : "-" },
    { id: 6, name: 'cdate', label: 'Creation Date', sortable: true, type: 'date', component: (row) => moment(row.cdate).format('YYYY-MM-DD') },
  ],
  keyCol: 'ioNo',
  actions: [
    {
    type: 'download',
    text: '',
    icon: 'mdi mdi-download',
    tooltip: 'Edit'
  } 
],
  // recActive: true,
  // status: {
  //   key: 'rec_active',
  //   active: '1',
  //   activeIcon: 'mdi mdi-checkbox-marked',
  //   inActiveIcon: 'mdi mdi-close-box',
  //   confirmation: true,
  //   activeConfirmationMessage: 'Kindly confirm the deactivation of this record.',
  //   inActiveConfirmationMessage: 'Please confirm if you wish to activate this record.',
  // },
  actionsThead: true,
  sortable: true,
  dateType: true,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'desc'
  },
  paging: true,
  defaultPagingParams: {
    pageSize: 25
  }
};
